const Mutations = Object.freeze({
	SET_LOADING: 'applicationContext/SET_CURRENT_USER',
	SET_ERROR: 'applicationContext/SET_ERROR',
	SET_CLEAR_ERROR: 'applicationContext/SET_CLEAR_ERROR',
	SET_DRAWER: 'applicationContext/SET_DRAWER',
});

export const Actions = Object.freeze({
	LOADING: 'applicationContext/LOADING',
	ERROR: 'applicationContext/ERROR',
	CLEAR_ERROR: 'applicationContext/CLEAR_ERROR',
	UPDATE_DRAWER_STATE: 'applicationContext/UPDATE_DRAWER_STATE',
});

export const Getters = Object.freeze({
	IS_LOADING: 'applicationContext/IS_LOADING',
	DRAWER: 'applicationContext/DRAWER',
	HAS_ERROR: 'applicationContext/HAS_ERROR',
	GET_ERROR: 'applicationContext/GET_ERROR',
});

export default {
	state: {
		drawer: localStorage.drawer || null,
		loading: false,
		errors: [],
		hasError: false,
	},
	mutations: {
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_ERROR](state, error) {
			state.errors.push(error);
			state.hasError = true;
		},
		[Mutations.SET_CLEAR_ERROR](state) {
			state.hasError = false;
		},
		[Mutations.SET_DRAWER](state, value) {
			state.drawer = value;
			localStorage.drawer = value;
		},
	},
	actions: {
		[Actions.LOADING]({ commit }, value) {
			commit(Mutations.SET_LOADING, value);
		},
		[Actions.ERROR]({ commit }, value) {
			if (!value._hiddenModal) {
				commit(Mutations.SET_ERROR, value);
			}
		},
		[Actions.CLEAR_ERROR]({ commit }) {
			commit(Mutations.SET_CLEAR_ERROR);
		},
		[Actions.UPDATE_DRAWER_STATE]({ commit }, value) {
			commit(Mutations.SET_DRAWER, value);
		},
	},
	getters: {
		[Getters.IS_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.DRAWER]: (state) => {
			return state.drawer;
		},
		[Getters.HAS_ERROR]: (state) => {
			return state.hasError;
		},
		[Getters.GET_ERROR]: (state) => {
			if (state.errors && state.errors.length > 0) {
				let index = state.errors.length - 1;
				return state.errors[index];
			}
			return null;
		},
	},
};
